/** Namespace `partnerSets` — HQ-2026-008: bộ thông số + gán app trong hộp thoại « Cấu hình ». Bản gốc tiếng Việt. */
export const partnerSets = {
  setsTitle: "Bộ thông số",
  setsIntro: "Mỗi môi trường có nhiều bộ thông số có tên. Chạy thử ĐẠT rồi mới gán và bật cho app.",
  noSets: "Chưa có bộ nào ở môi trường này.",
  addSet: "Thêm bộ",
  name: "Tên bộ",
  namePlaceholder: "vd « Tài khoản UAT chính »",
  edit: "Sửa",
  cancel: "Huỷ",
  save: "Lưu",
  saving: "Đang lưu…",
  create: "Tạo bộ",
  delete: "Xoá",
  confirmDelete: "Xoá bộ « {name} »?",
  deleted: "Đã xoá.",
  saved: "Đã lưu. Bộ phải chạy thử lại trước khi bật cho app mới.",
  runTest: "Chạy thử",
  testing: "Đang chạy thử…",
  merchantIdOptional: "Merchant ID (tuỳ chọn, cho bước danh sách VA)",
  openLab: "Phòng thử",
  openAgency: "Đại lý",
  sendTest: "Gửi thử thư thật →",
  sendTestTitle: "Mở trang Gửi mail: mỗi app đang bật bộ này có nút « Gửi thử » — máy chủ của app gửi một thư thật bằng chính bộ này.",
  sendTestNeedsRoute: "Chưa là tuyến của app nào — chọn ở trang Mail của app (qua cổng kiểm)",
  routeOf: "Đang là tuyến của:",
  "routeRole.primary": "chính",
  "routeRole.standby": "dự phòng",
  "routeRole.disabled": "tắt",
  manageRoutesAt: "Chọn tuyến ở trang Mail · {app}",
  migrated: "chuyển từ bản cũ",
  boundTo: "Đang gán: {apps}",
  notBound: "Chưa gán cho app nào",
  lastTest: "Chạy thử lần cuối {when} · {by}",
  neverTested: "Chưa chạy thử",
  "status.untested": "Chưa chạy thử",
  "status.passed": "Đạt",
  "status.failed": "Không đạt",
  "level.auth": "xác thực khoá",
  "level.reachability": "chỉ máy chủ trả lời — CHƯA kiểm khoá",
  "level.suite": "bộ bước không phá huỷ",
  "step.ok": "đạt",
  "step.failed": "trượt",
  "step.unknown": "không rõ",
  "step.skipped": "bỏ qua",
  showReport: "Xem báo cáo",
  hideReport: "Ẩn báo cáo",
  bindingsTitle: "Gán cho app",
  bindingsIntro: "App nào dùng bộ nào ở môi trường này. Công tắc chỉ mở khi bộ đã chạy thử ĐẠT.",
  app: "App",
  set: "Bộ",
  enabled: "Bật",
  chooseSet: "— chọn bộ —",
  grandfathered: "Đang bật từ trước — bộ CHƯA chạy thử. Hãy chạy thử.",
  // PLAT-2026-120 GĐ5 — gán email grandfathered của app có tuyến hub: công tắc bật nhưng hub KHÔNG gửi mail qua nó.
  previousUntil: "Bộ cũ « {name} » vẫn được gửi kèm (chỉ kiểm tin đẩy tới) tới {when}.",
  needsPassed: "Chạy thử bộ này ĐẠT rồi mới bật được.",
  switchNeedsPassed: "App đang BẬT — chỉ đổi sang bộ đã chạy thử ĐẠT (hoặc tắt trước).",
  confirmDisable: "Tắt {app} ({env})?",
  alwaysOn: "Luôn bật",
  alwaysOnTitle: "Sandbox luôn bật cho mọi app — không có công tắc. Chỉ production (live) chờ hub bật.",
  bindingsIntroSandbox: "App nào dùng bộ nào ở sandbox. Sandbox LUÔN BẬT — chưa gán bộ thì app dùng giá trị công khai của danh mục (URL gốc…); bộ chỉ cần đủ thông số, không cần chạy thử.",
  catalogFallback: "Chưa gán — dùng giá trị danh mục.",
  bindingSaved: "Đã cập nhật gán.",
  failed: "Không thực hiện được.",
  credentialsChangedWarning: "Bộ này đang BẬT cho app — đổi khoá sẽ áp ngay và bộ quay về « chưa chạy thử ».",
  // PLAT-2026-135 lát L — trường « chỉ ở hub » + hai số phiên bản của bộ.
  hubOnly: "chỉ ở hub",
  hubOnlyHint: "Hub giữ trường này để đọc tài khoản nhà cung cấp — KHÔNG BAO GIỜ gửi xuống app. Sửa riêng nó không đổi cấu hình gửi và không cần chạy thử lại.",
  versionPair: "Bộ thông số v{n} · Cấu hình gửi v{delivery}",
  hubOnlyEditNotice: "Chỉ đổi trường « chỉ ở hub »: app không nhận gì mới — không ân hạn khoá cũ, không đẩy cấu hình, bộ giữ kết quả chạy thử hiện tại.",
  deliveryVersionHint: "« Cấu hình gửi » là phần app nhận (mọi trường trừ « chỉ ở hub ») — chỉ tăng khi phần đó đổi. Sửa khoá quản trị chỉ tăng số bộ thông số.",
  // BANK-2026-038 T4.7 — cách đối tác tính phí Bube.
  pricingTitle: "Cách đối tác tính phí Bube",
  pricingIntro: "Chọn kiểu tính phí và nhập giá theo hợp đồng của bộ này. Đổi giá = thêm mức mới với ngày hiệu lực; mức đã hiệu lực là lịch sử, không xoá.",
  pricingNone: "Chưa cấu hình giá — app coi như tính theo giao dịch (tạm dừng vẫn ngừng ở đối tác).",
  pricingCurrent: "đang áp dụng",
  pricingFuture: "từ {date}",
  pricingFrom: "Hiệu lực từ",
  pricingModel: "Kiểu tính phí",
  pricingScope: "Tính trên",
  pricingUnitPrice: "Giá mỗi giao dịch (₫)",
  pricingFree: "Giao dịch miễn phí mỗi tháng",
  pricingMonthlyFee: "Phí tháng (₫)",
  pricingIncluded: "Số giao dịch trong hạn mức",
  pricingOverage: "Giá mỗi giao dịch vượt (₫, để trống = đối tác ngừng báo)",
  pricingAdd: "Thêm mức giá",
  pricingAdded: "Đã thêm mức giá.",
  pricingDelete: "Xoá mức chưa hiệu lực",
  pricingInvalid: "Giá phải là số nguyên không âm (đồng).",
  pricingSummaryTx: "{price}/giao dịch",
  pricingSummaryFree: ", miễn phí {count}/tháng",
  pricingSummaryMonthly: "{fee}/tháng",
  pricingSummaryCapped: "{fee}/tháng gồm {count} giao dịch, vượt {over}/giao dịch",
  pricingSummaryCappedStop: "{fee}/tháng gồm {count} giao dịch, vượt thì ngừng báo",
} as const;
